export const title = "Universo Cole 2023"
export const description = "Juega con Nosotras en nuestros diferentes mundos como Snake, 3 en linea, y Tetris, gana puntos y sube en la escalera del top de Universo Cole 2023 para ganar muchos premios jugando con Nosotras"
